import { useState } from "react";
import "styles/components/forms/inputs/switchInput.css";

interface SwitchInputProps {
  onSwitchChange?: (isOn: boolean) => void;
}

const SwitchInput = ({ onSwitchChange }: SwitchInputProps) => {
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    const newIsOn = !isOn;
    setIsOn(newIsOn);

    if (onSwitchChange) {
      onSwitchChange(newIsOn);
    }
  };

  return (
    <div
      className={`switch ${isOn ? "switch-on" : "switch-off"}`}
      onClick={handleToggle}
    >
      <div className="switch-handle"></div>
    </div>
  );
};

export default SwitchInput;
